/**
 * Unified App Providers Configuration
 *
 * This file configures all application providers using the core plugins.
 * Provider order (outer → inner):
 * 1. QueriesProvider - TanStack Query + persistence
 * 2. WebSocketProvider - Real-time updates
 * 3. AuthProvider - Authentication state (in root route)
 * 4. PageConfigProvider - Page generator configuration
 *
 * Note: Localization is initialized via initLocalization() hook from context/locale setup
 */

import { QueriesProvider } from '@gaddario98/react-core/queries'
import { WebSocketProvider } from './WebSocketProvider'
import type { ProviderConfig } from '@gaddario98/react-core/providers'

/**
 * Provider configuration array for AppProviders
 * These providers wrap the entire application
 */
export const appProviders: Array<ProviderConfig> = [
  [QueriesProvider, {}],
  [WebSocketProvider, {}],
]
